export default "__VITE_ASSET__Cb36RDOq__"